// @ts-check
/**
 * @file useNavGuard.js
 * @location src/hooks/useNavGuard.js
 * @role 매니저 전용 페이지(NAV_ITEMS.managerOnly)에 비매니저 직접 진입 시 업무 탭으로 보정 (razor ⑳).
 *   설정은 nav 가 아니라 모달(진입점이 매니저 게이트)·마이 페이지는 전원 접근이라 여기서 안 다룸.
 */
import { useEffect } from 'react';
import { NAV_ITEMS } from '../data/navItems.js';

/**
 * @param {object} p
 * @param {string} p.activeNav
 * @param {boolean} p.isManager
 * @param {(type: string, patch?: object) => void} p.act
 */
export function useNavGuard({ activeNav, isManager, act }) {
  useEffect(() => {
    const item = NAV_ITEMS.find(n => n.key === activeNav);
    if (item?.managerOnly && !isManager) {
      act('SET_NAV', { nav: 'tasks' });
    }
  }, [activeNav, isManager, act]);
}
